import { defineComponent as o } from "vue";
import c from "../Components/NcButton.mjs";
import { N as l } from "./NcIconSvgWrapper-P-GkSjTH.mjs";
import { n as i } from "./_plugin-vue2_normalizer-u6G_3nkj.mjs";
const a = o({
  name: "NcDialogButton",
  components: {
    NcButton: c,
    NcIconSvgWrapper: l
  },
  props: {
    /**
     * The function that will be called when the button is pressed
     * @type {() => void}
     */
    callback: {
      type: Function,
      required: !0
    },
    /**
     * The label of the button
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Optional inline SVG icon for the button
     */
    icon: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * The button type, see NcButton
     * @type {'primary'|'secondary'|'error'|'warning'|'success'}
     */
    type: {
      type: String,
      required: !1,
      default: "secondary",
      validator: (n) => typeof n == "string" && ["primary", "secondary", "error", "warning", "success"].includes(n)
    }
  },
  emits: ["click"],
  setup(n, { emit: e }) {
    return { handleClick: (t) => {
      n.callback?.(), e("click", t);
    } };
  }
});
var s = function() {
  var e = this, r = e._self._c;
  return e._self._setupProxy, r("NcButton", { attrs: { "aria-label": e.label, type: e.type }, on: { click: e.handleClick }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [e._t("icon", function() {
      return [e.icon !== void 0 ? r("NcIconSvgWrapper", { attrs: { svg: e.icon } }) : e._e()];
    })];
  }, proxy: !0 }], null, !0) }, [e._v(" " + e._s(e.label) + " ")]);
}, u = [], p = /* @__PURE__ */ i(
  a,
  s,
  u,
  !1,
  null,
  null,
  null,
  null
);
const y = p.exports;
export {
  y as N
};
